import React from 'react';
import { LandingComponent } from 'app/types';
import { LandingComponentButton, ButtonSize, ButtonStyle } from 'app/types';
import ReactMarkdown from 'react-markdown';
import { Link } from 'react-router-dom';
import { BUTTONSTYLE, BUTTONSIZE } from 'common/constants';

interface PreviewComponentProps {
  landing_cmp: LandingComponent;
}

const CardGridPreview = ({ landing_cmp }: PreviewComponentProps): React.ReactElement => {
  const renderCard = (card: any, type: string) => {
    return (
      <div
        className={`ua-cms__card card border-0 h-100 ${
          type === 'side_image' ? 'd-flex flex-column flex-md-row align-items-center' : ''
        } ${type === 'standard' ? 'shadow-sm' : ''} ${
          type === 'only_image' ? 'd-flex justify-content-center' : ''
        }`}
        style={{
          backgroundColor: card.config.card_background ? card.config.card_background : 'white',
        }}
      >
        {card.image_file && typeof card.image_file === 'string' && (
          <img
            src={card.image_file}
            className={`img-fluid ${type === 'side_image' ? 'col-md-4' : ''}`}
          ></img>
        )}
        {(card.config.card_title || card.config.card_text) && (
          <div
            className={`card-body p-4 text-center ${type === 'side_image' ? 'text-md-start' : ''}`}
          >
            {card.config.card_title && (
              <h5
                className={`card-title text-dark-primary mb-3 d-flex justify-content-center align-items-center ${
                  card.config.icon_style === 'on_top' ? 'flex-column' : 'flex-row'
                } ${type === 'just_text' ? 'display-5 fw-semibold' : ''}`}
              >
                {card.config.icon_name && <i className={`bi bi-${card.config.icon_name}`}></i>}
                <span>{card.config.card_title}</span>
              </h5>
            )}
            {card.config.card_text && (
              <div className="card-text">
                <ReactMarkdown>{card.config.card_text}</ReactMarkdown>
              </div>
            )}
          </div>
        )}
      </div>
    );
  };
  return (
    <div className="py-3">
      <div
        className={`row ${
          landing_cmp.config.display_overflow === 'carousel'
            ? `flex-nowrap row-cols-${landing_cmp.config.columns_sm} row-cols-carousel`
            : 'row-cols-1'
        } row-cols-md-${landing_cmp.config.columns_md} row-cols-lg-${
          landing_cmp.config.columns_lg
        }`}
      >
        {landing_cmp.sub_landing_components.map((card) => (
          <div className="col my-2" key={card.id}>
            {renderCard(card, landing_cmp.config.card_style)}
          </div>
        ))}
      </div>
      {landing_cmp.landing_component_buttons.length > 0 && (
        <div className="row d-flex flex-column flex-sm-row justify-content-center px-4 px-sm-0">
          {landing_cmp.landing_component_buttons.map((button: LandingComponentButton) => {
            const buttonStyle: ButtonStyle = button.style as keyof typeof BUTTONSTYLE;
            const buttonSize: ButtonSize = button.size as keyof typeof BUTTONSIZE;
            return (
              <Link
                key={button.id}
                to={button.link}
                className={`btn fw-medium rounded-pill w-auto mt-4 px-5 me-sm-2 mb-3 mb-sm-0 col-12 col-sm-auto ${BUTTONSTYLE[buttonStyle]} ${BUTTONSIZE[buttonSize]}`}
              >
                {button.text}
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CardGridPreview;
